// TODO: спросить по поводу зеленого цвета
export const colorIndexesFundingNeeds = {
  green: [12, 10, 7, 16],
  blue: [5, 10, 0, 6],
  red: [5, 21, 0, 6],
  blueGreen: [5, 0, 28, 8],
  blueRed: [1, 36, 8, 18],
  blueYellow: [29, 10, 8, 13],
};

export const colorIndexesFundingStrategy = {
  green: [12, 7, 16, 14, 34, 20],
  blue: [20, 12, 0, 22, 25, 13],
  red: [20, 12, 0, 13, 16, 22],
  blueGreen: [5, 10, 0, 13, 24, 19],
  blueRed: [20, 12, 21, 16, 17, 15],
  blueYellow: [20, 12, 21, 13, 28, 15],
};
